import { render, staticRenderFns } from "./luxury.vue?vue&type=template&id=fe789a82&scoped=true&"
import script from "./luxury.vue?vue&type=script&lang=js&"
export * from "./luxury.vue?vue&type=script&lang=js&"
import style0 from "./luxury.vue?vue&type=style&index=0&id=fe789a82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe789a82",
  null
  
)

export default component.exports